export { default } from './Statistic'
